import styled from "styled-components";
import React, {useEffect, useState} from "react";
import Images from "../../assets/images/Images";
import Colors from "../../assets/colors/Colors";
import SplashBridge from "./SplashBridge";

const SplashWrapper = styled.div`
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: white;
`;

const TextWrapper = styled.div `
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 18px;
`;

const Splash1: React.FC<{show: boolean}> = ({ show }) => {

  return (
      <>
        <SplashWrapper>
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}} >
            <div>
              <img style={{height: 100, width: 350}} src={Images.logoWhiteBgEconomics}/>
            </div>
            <div>
              <SplashBridge showBridge={ show }/>
            </div>
          </div>
        </SplashWrapper>
      </>
  )
}

const Splash2: React.FC<{show: boolean}> = ({ show }) => {

  return (
      <>
        <SplashWrapper>
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}} >
            <div>
              <img style={{height: 100, width: 350}} src={Images.logoWhiteBgEconomics}/>
            </div>
            <TextWrapper>
              <div style={{fontFamily: 'DMSans-Black', marginBottom: 20}}>
                ÍNDICE DE POTENCIAL ASEGURADOR
              </div>
              <div style={{fontFamily: 'DMSans-Light'}}>
                GLOBAL INSURANCE POTENTIAL INDEX
              </div>
              <div style={{fontFamily: 'DMSans-Light'}}>
                (GIP)
              </div>
            </TextWrapper>
          </div>
        </SplashWrapper>
      </>
  )
}

const SplashContainer: React.FC<{show: boolean}> = ({ show }) => {

  const [showSplash2, setShowSplash2] = useState(false);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShowSplash2(true);
      }, 1000)
    }
  }, [show]);

  return (
    <>
      {
        showSplash2 ? <Splash2 show={show} /> : <Splash1 show={show}/>
      }
    </>
  )
};

export default SplashContainer;
